import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Modal, Button } from 'react-bootstrap';
import { makeGetRequest } from '../services/httpHelper';
import styled from 'styled-components';
import VideoCover from '../assets/images/videocover.jpg'
import 'bootstrap/dist/css/bootstrap.min.css';



const Section = styled.section`
  padding: 60px 0;
`;

const StyledCard = styled(Card)`
  border: none;
  box-shadow: 0 0 15px rgba(0,0,0,0.05);
  transition: 0.3s;

  &:hover {
    transform: translateY(-5px);
  }

  .card-img-top {
    height: 180px;
    object-fit: cover;
  }
`;

const VideoSermonList = () => {
  const [sermons, setSermons] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState('');
  const [videoTitle, setVideoTitle] = useState('');


  useEffect(() => {
    (async () => {
      const church = JSON.parse(localStorage.getItem('church'));
      const res = await makeGetRequest(`video-sermons/${church.id}`);
      if (res?.data) setSermons(res.data);
    })();
  }, []);

const openModal = (url,title) => {
  // Extract YouTube video ID
  let videoId = '';
  setVideoTitle(title)

  try {
    const urlObj = new URL(url);
    if (urlObj.hostname.includes('youtu.be')) {
      // Short URL format
      videoId = urlObj.pathname.slice(1);
    } else if (urlObj.hostname.includes('youtube.com')) {
      videoId = urlObj.searchParams.get('v');
    }
  } catch (e) {
    console.error('Invalid video URL:', url);
    return;
  }

  if (videoId) {
    const embedUrl = `https://www.youtube.com/embed/${videoId}`;
    console.log('embedUrl ',embedUrl)

    setCurrentVideoUrl(embedUrl);
    console.log('currentVideoUrl',currentVideoUrl)
    setModalShow(true);
  } else {
    console.warn('Unable to extract video ID');
  }
};

  return (
    <Section>
      <Container>
        <h2 className="text-center mb-5">All Video Sermons</h2>
        <Row>
          {sermons.map((sermon) => (
            <Col md={4} sm={6} key={sermon.id} className="mb-4">
              <StyledCard>
                <Card.Img variant="top" src={sermon.thumbnail || VideoCover}/>
                <Card.Body>
                  <Card.Title>{sermon.title}</Card.Title>
                  <p>{sermon.description}</p>
                  <p>{sermon.body}</p>

                  <Button variant="primary" onClick={() => openModal(sermon.body,sermon.title)}>Watch</Button>
                </Card.Body>
              </StyledCard>
            </Col>
          ))}
        </Row>

        <Modal
  size="lg"
  centered
  show={modalShow}
  onHide={() => setModalShow(false)}
  backdrop="static"
  animation={false}
  dialogClassName="video-modal"
>
 <Modal.Header style={{ backgroundColor: '#000', borderBottom: 'none' }}>
  <button
    type="button"
    className="btn-close"
    aria-label="Close"
    onClick={() => setModalShow(false)}
    style={{
      filter: 'invert(1)',
      position: 'absolute',
      top: '10px',
      right: '10px',
      zIndex: 1051,
    }}
  />
</Modal.Header>
  <Modal.Body style={{ padding: 0, backgroundColor: '#000' }}>
    <div style={{ position: 'relative', paddingTop: '56.25%' }}>
      <iframe
        title="Sermon Video"
        src={`${currentVideoUrl}?autoplay=1&rel=0`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 'none',
          transform: 'translateZ(0)',
        }}
      />
    </div>
  </Modal.Body>
</Modal>


  {/*<Modal
  size="lg"
  centered
  show={modalShow}
  onHide={() => setModalShow(false)}
  backdrop="static"
  contentClassName="custom-modal-content"
  className='modal-backdrop modal modal-content video-modal'
  animation={false}
>
  <Modal.Header closeButton style={{ backgroundColor: '#000', borderBottom: 'none' }} />
  <Modal.Body style={{ padding: 0, backgroundColor: 'black' }}>
    <div style={{ position: 'relative', paddingTop: '56.25%' }}>
      <iframe
        title="Sermon Video"
        src={`${currentVideoUrl}?autoplay=1&rel=0`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 'none',
        }}
      />
    </div>
  </Modal.Body>
</Modal>*/}




      </Container>
    </Section>
  );
};

export default VideoSermonList;
